<template>
  <q-list bordered class="rounded-borders" style="max-width: 350px">
    <q-item-label header class="q-pb-none">
      Corresponding Author
    </q-item-label>

    <q-item>
      <q-item-section>
        <q-item-label class="text-subtitle2">
          {{ article.corresponding_author || 'N/A' }}
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
export default {
  props: {
    article: Object
  }
}
</script>
